<div class="h-full overflow-hidden">
  <div class="flex gap-4 p-4 text-xl font-bold items-center">
    <wun-editorials-icon />
    Editorials ><p class="capitalize">{{routeName()}}</p>
  </div>
  <div class="flex h-full flex-1 overflow-auto">
    <div class="w-80 flex flex-col border">
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active" routerLink="/backoffice/editorials/slides">Homepage</a>
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active" routerLink="/backoffice/editorials/exhibitions">Esibizione</a>
    </div>
    <div class="w-full border">
      <router-outlet/>
    </div>
  </div>
</div>
